import React, { Component } from 'react';
import uuid from 'uuid/v4';
import { defineMessages, injectIntl } from 'react-intl';
import CostComponents from './cost-components';
import PaymentsSchedule from './payments-schedule';
import PriceRanges from './price-ranges';
import LinkWithPopover from './link-with-popover';
import Purchase from '../lib/purchase';
import { TOTAL } from '../lib/cost-types';
import { formatMessage } from '../../lib/intl';

class PaymentScheduleLink extends Component {
  constructor(props) {
    super(props);
    this.paymentScheduleElementKey = uuid();
    this.priceRangesKey = uuid();
    this.formatMessage = formatMessage(this.props.intl);
    this.i18n = defineMessages({
      paymentSchedule: {
        id: 'paymentSchedule.label.paymentSchedule',
        defaultMessage: 'Payment schedule',
      },
      details: {
        id: 'paymentSchedule.label.details',
        defaultMessage: 'Details',
      },
    });
  }

  label() {
    if (this.props.asIcon) return <i className="fa fa-fw fa-clock-o cool-grey" />;

    return this.isMultiPayment() ? this.formatMessage(this.i18n.paymentSchedule) :
      this.formatMessage(this.i18n.details);
  }

  isTotalCostType() {
    return Purchase.isTotal(this.props.costType);
  }

  hasCostComponents() {
    return this.props.costComponents.length > 0;
  }

  isMultiPayment() {
    return this.props.payments.length > 1;
  }

  hasPricingArray() {
    return this.props.costs.length > 1;
  }

  renderComponents() {
    const components = [];
    const { costs: totalCosts, payments, costComponents } = this.props;

    if (this.isMultiPayment()) {
      const paymentsProps = {
        payments,
        totalAmount: this.props.totalAmount,
        refundableAmount: this.props.refundableAmount,
        consumerFee: this.props.consumerFee,
        key: this.paymentScheduleElementKey,
        forMember: this.props.forMember,
      };
      components.push(<PaymentsSchedule {...paymentsProps} />);
    }

    if (this.hasPricingArray()) {
      const priceRangesProps = {
        totalCosts,
        perPerson: !this.isTotalCostType(),
        key: this.priceRangesKey,
      };
      components.push(<PriceRanges {...priceRangesProps} />);
    }

    if (this.hasCostComponents()) {
      const costComponentsProps = { costComponents };
      components.push(<CostComponents {...costComponentsProps} />);
    }

    return components;
  }

  render() {
    const components = this.renderComponents();

    if (components.length === 0) return null;

    return (
      <LinkWithPopover
        name="payment-schedule"
        text={this.label()}
        placement="left"
        className="small-print payment-schedule-link"
        constraints={this.props.constraints}
      >
        <div>{components}</div>
      </LinkWithPopover>
    );
  }
}

PaymentScheduleLink.defaultProps = {
  constraints: [{ elem: '.main-container', pin: ['left'] }],
  costComponents: [],
  costs: [],
  costType: TOTAL,
  payments: [],
  asIcon: false,
};

export default injectIntl(PaymentScheduleLink);



// WEBPACK FOOTER //
// ./src/desktop/components/payment-schedule-link.js